module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mentor"
  }, [_c('MentoringAvatar', {
    attrs: {
      "size": "normal",
      "gender": _vm.gender,
      "photo": _vm.image,
      "type": _vm.type
    }
  }), _c('div', {
    staticClass: "mentor__info"
  }, [_c('p', {
    staticClass: "mentor__type"
  }, [_vm._v(_vm._s(_vm.typeText))]), _c('p', {
    staticClass: "mentor__name"
  }, [_vm._v(_vm._s(_vm.name)), _c('br'), _vm._v(_vm._s(_vm.lastname))]), _c('p', {
    staticClass: "mentor__text"
  }, [_vm._v(_vm._s(_vm.email)), _c('br'), _vm._v(_vm._s(_vm.phone))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5314b1c6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/teamcard/components/mentor/MentoringTeamCardMentor.vue
// module id = 946a80d5d8df02270c6d
// module chunks = 89